<mat-paginator *ngIf="pagination" [pageIndex]="pagination.pageNumber - 1" [pageSize]="pagination.pageSize"
    [pageSizeOptions]="[10, 15, 25, 100]" [length]="pagination.totalRecords" [showFirstLastButtons]="true"
    [disabled]="isDisabled" (page)="onPagechange($event)"></mat-paginator>